<template>
  <div id="app">
    <search v-if="landValue === undefined" @rate-found="valueSubmitted"/>
    <div class="container" v-else>
      <h2>Summary</h2>
      <p>Land Value: <b>${{ landValue.toLocaleString() }}</b></p>
      <comparison :land-value="landValue" />
      <borrowings />
    </div>
  </div>
</template>

<script>

    import Search from "@/components/Search";
    import Comparison from "@/components/Comparison";
    import Borrowings from "@/components/Borrowings";

    export default {
        name: 'App',
        components: {
            Borrowings,
            Comparison,
            Search
        },
        data() {
            return {
                landValue: undefined,
            };
        },
        methods: {
            valueSubmitted(value) {
                this.landValue = value;
            }
        }
    }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 30px;
  }
</style>
